export default {
    "AF": {
        "name": "Afganistán"
    },
    "AL": {
        "name": "Albania"
    },
    "DE": {
        "name": "Alemania"
    },
    "AD": {
        "name": "Andorra"
    },
    "AO": {
        "name": "Angola"
    },
    "AG": {
        "name": "Antigua y Barbuda"
    },
    "SA": {
        "name": "Arabia Saudita"
    },
    "DZ": {
        "name": "Argelia"
    },
    "AR": {
        "name": "Argentina"
    },
    "AM": {
        "name": "Armenia"
    },
    "AU": {
        "name": "Australia"
    },
    "AT": {
        "name": "Austria"
    },
    "AZ": {
        "name": "Azerbaiyán"
    },
    "BS": {
        "name": "Bahamas"
    },
    "BD": {
        "name": "Bangladés"
    },
    "BB": {
        "name": "Barbados"
    },
    "BH": {
        "name": "Baréin"
    },
    "BE": {
        "name": "Bélgica"
    },
    "BZ": {
        "name": "Belice"
    },
    "BJ": {
        "name": "Benín"
    },
    "BY": {
        "name": "Bielorrusia"
    },
    "BO": {
        "name": "Bolivia"
    },
    "BA": {
        "name": "Bosnia y Herzegovina"
    },
    "BW": {
        "name": "Botsuana"
    },
    "BR": {
        "name": "Brasil"
    },
    "BN": {
        "name": "Brunéi"
    },
    "BG": {
        "name": "Bulgaria"
    },
    "BF": {
        "name": "Burkina Faso"
    },
    "BI": {
        "name": "Burundi"
    },
    "BT": {
        "name": "Bután"
    },
    "CV": {
        "name": "Cabo Verde"
    },
    "KH": {
        "name": "Camboya"
    },
    "CM": {
        "name": "Camerún"
    },
    "CA": {
        "name": "Canadá"
    },
    "QA": {
        "name": "Catar"
    },
    "TD": {
        "name": "Chad"
    },
    "CL": {
        "name": "Chile"
    },
    "CN": {
        "name": "China"
    },
    "CY": {
        "name": "Chipre"
    },
    "CO": {
        "name": "Colombia"
    },
    "KM": {
        "name": "Comoras"
    },
    "KP": {
        "name": "Corea del Norte"
    },
    "KR": {
        "name": "Corea del Sur"
    },
    "CI": {
        "name": "Costa de Marfil"
    },
    "CR": {
        "name": "Costa Rica"
    },
    "HR": {
        "name": "Croacia"
    },
    "CU": {
        "name": "Cuba"
    },
    "DK": {
        "name": "Dinamarca"
    },
    "DM": {
        "name": "Dominica"
    },
    "EC": {
        "name": "Ecuador"
    },
    "EG": {
        "name": "Egipto"
    },
    "SV": {
        "name": "El Salvador"
    },
    "AE": {
        "name": "Emiratos Árabes Unidos"
    },
    "ER": {
        "name": "Eritrea"
    },
    "SK": {
        "name": "Eslovaquia"
    },
    "SI": {
        "name": "Eslovenia"
    },
    "ES": {
        "name": "España"
    },
    "US": {
        "name": "Estados Unidos"
    },
    "EE": {
        "name": "Estonia"
    },
    "ET": {
        "name": "Etiopía"
    },
    "PH": {
        "name": "Filipinas"
    },
    "FI": {
        "name": "Finlandia"
    },
    "FJ": {
        "name": "Fiyi"
    },
    "FR": {
        "name": "Francia"
    },
    "GA": {
        "name": "Gabón"
    },
    "GM": {
        "name": "Gambia"
    },
    "GE": {
        "name": "Georgia"
    },
    "GH": {
        "name": "Ghana"
    },
    "GD": {
        "name": "Granada"
    },
    "GR": {
        "name": "Grecia"
    },
    "GT": {
        "name": "Guatemala"
    },
    "GN": {
        "name": "Guinea"
    },
    "GW": {
        "name": "Guinea-Bisáu"
    },
    "GQ": {
        "name": "Guinea Ecuatorial"
    },
    "GY": {
        "name": "Guyana"
    },
    "HT": {
        "name": "Haití"
    },
    "HN": {
        "name": "Honduras"
    },
    "HU": {
        "name": "Hungría"
    },
    "IN": {
        "name": "India"
    },
    "ID": {
        "name": "Indonesia"
    },
    "IQ": {
        "name": "Irak"
    },
    "IR": {
        "name": "Irán"
    },
    "IE": {
        "name": "Irlanda"
    },
    "IS": {
        "name": "Islandia"
    },
    "MH": {
        "name": "Islas Marshall"
    },
    "SB": {
        "name": "Islas Salomón"
    },
    "IL": {
        "name": "Israel"
    },
    "IT": {
        "name": "Italia"
    },
    "JM": {
        "name": "Jamaica"
    },
    "JP": {
        "name": "Japón"
    },
    "JO": {
        "name": "Jordania"
    },
    "KZ": {
        "name": "Kazajistán"
    },
    "KE": {
        "name": "Kenia"
    },
    "KG": {
        "name": "Kirguistán"
    },
    "KI": {
        "name": "Kiribati"
    },
    "KW": {
        "name": "Kuwait"
    },
    "LA": {
        "name": "Laos"
    },
    "LS": {
        "name": "Lesoto"
    },
    "LV": {
        "name": "Letonia"
    },
    "LB": {
        "name": "Líbano"
    },
    "LR": {
        "name": "Liberia"
    },
    "LY": {
        "name": "Libia"
    },
    "LI": {
        "name": "Liechtenstein"
    },
    "LT": {
        "name": "Lituania"
    },
    "LU": {
        "name": "Luxemburgo"
    },
    "MK": {
        "name": "Macedonia del Norte"
    },
    "MG": {
        "name": "Madagascar"
    },
    "MY": {
        "name": "Malasia"
    },
    "MW": {
        "name": "Malaui"
    },
    "MV": {
        "name": "Maldivas"
    },
    "ML": {
        "name": "Malí"
    },
    "MT": {
        "name": "Malta"
    },
    "MA": {
        "name": "Marruecos"
    },
    "MU": {
        "name": "Mauricio"
    },
    "MR": {
        "name": "Mauritania"
    },
    "MX": {
        "name": "México"
    },
    "FM": {
        "name": "Micronesia"
    },
    "MD": {
        "name": "Moldavia"
    },
    "MC": {
        "name": "Mónaco"
    },
    "MN": {
        "name": "Mongolia"
    },
    "ME": {
        "name": "Montenegro"
    },
    "MZ": {
        "name": "Mozambique"
    },
    "MM": {
        "name": "Birmania"
    },
    "NA": {
        "name": "Namibia"
    },
    "NR": {
        "name": "Nauru"
    },
    "NP": {
        "name": "Nepal"
    },
    "NI": {
        "name": "Nicaragua"
    },
    "NE": {
        "name": "Níger"
    },
    "NG": {
        "name": "Nigeria"
    },
    "NO": {
        "name": "Noruega"
    },
    "NZ": {
        "name": "Nueva Zelanda"
    },
    "OM": {
        "name": "Omán"
    },
    "NL": {
        "name": "Países Bajos"
    },
    "PK": {
        "name": "Pakistán"
    },
    "PW": {
        "name": "Palaos"
    },
    "PA": {
        "name": "Panamá"
    },
    "PG": {
        "name": "Papúa Nueva Guinea"
    },
    "PY": {
        "name": "Paraguay"
    },
    "PE": {
        "name": "Perú"
    },
    "PL": {
        "name": "Polonia"
    },
    "PT": {
        "name": "Portugal"
    },
    "GB": {
        "name": "Reino Unido"
    },
    "CF": {
        "name": "República Centroafricana"
    },
    "CZ": {
        "name": "República Checa"
    },
    "CG": {
        "name": "República del Congo"
    },
    "CD": {
        "name": "República Democrática del Congo"
    },
    "DO": {
        "name": "República Dominicana"
    },
    "RW": {
        "name": "Ruanda"
    },
    "RO": {
        "name": "Rumania"
    },
    "RU": {
        "name": "Rusia"
    },
    "WS": {
        "name": "Samoa"
    },
    "KN": {
        "name": "San Cristóbal y Nieves"
    },
    "SM": {
        "name": "San Marino"
    },
    "VC": {
        "name": "San Vicente y las Granadinas"
    },
    "LC": {
        "name": "Santa Lucía"
    },
    "ST": {
        "name": "Santo Tomé y Príncipe"
    },
    "SN": {
        "name": "Senegal"
    },
    "RS": {
        "name": "Serbia"
    },
    "SC": {
        "name": "Seychelles"
    },
    "SL": {
        "name": "Sierra Leona"
    },
    "SG": {
        "name": "Singapur"
    },
    "SY": {
        "name": "Siria"
    },
    "SO": {
        "name": "Somalia"
    },
    "LK": {
        "name": "Sri Lanka"
    },
    "SZ": {
        "name": "Suazilandia"
    },
    "ZA": {
        "name": "Sudáfrica"
    },
    "SD": {
        "name": "Sudán"
    },
    "SS": {
        "name": "Sudán del Sur"
    },
    "SE": {
        "name": "Suecia"
    },
    "CH": {
        "name": "Suiza"
    },
    "SR": {
        "name": "Surinam"
    },
    "TH": {
        "name": "Tailandia"
    },
    "TZ": {
        "name": "Tanzania"
    },
    "TJ": {
        "name": "Tayikistán"
    },
    "TL": {
        "name": "Timor Oriental"
    },
    "TG": {
        "name": "Togo"
    },
    "TO": {
        "name": "Tonga"
    },
    "TT": {
        "name": "Trinidad y Tobago"
    },
    "TN": {
        "name": "Túnez"
    },
    "TM": {
        "name": "Turkmenistán"
    },
    "TR": {
        "name": "Turquía"
    },
    "TV": {
        "name": "Tuvalu"
    },
    "UA": {
        "name": "Ucrania"
    },
    "UG": {
        "name": "Uganda"
    },
    "UY": {
        "name": "Uruguay"
    },
    "UZ": {
        "name": "Uzbekistán"
    },
    "VU": {
        "name": "Vanuatu"
    },
    "VE": {
        "name": "Venezuela"
    },
    "VN": {
        "name": "Vietnam"
    },
    "YE": {
        "name": "Yemen"
    },
    "DJ": {
        "name": "Yibuti"
    },
    "ZM": {
        "name": "Zambia"
    },
    "ZW": {
        "name": "Zimbabue"
    }
}